<template>
  <div class="identifition-log-staff" ref="identifitionLogStaff">
    <div class="app-search-controls">
      <div class="wrap">
        <p>员工姓名</p>
        <el-input placeholder="请输入员工姓名" v-model="search.name"></el-input>
      </div>
      <div class="wrap">
        <p>到访项目</p>
        <el-select v-model="search.project" placeholder="请选择到访项目" @change="positionChange" clearable>
          <el-option v-for="(value, index) in projectOptions" :key="index" :label="value.value" :value="value.value"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>抓拍位置</p>
        <el-select v-model="search.position" placeholder="请选择抓拍位置" clearable>
          <el-option v-for="(value, index) in positionOptions" :key="index" :label="value" :value="value"></el-option>
        </el-select>
      </div>
      <div class="wrap">
        <p>抓拍日期</p>
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.period" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
      </div>
    </div>
    <div class="app-control app-table-control">
      <el-button type="primary" @click="searchParams">搜索</el-button>
      <el-button @click="resetParams">重置</el-button>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="姓名" prop="user_data.attr_data.user_attr_name"></el-table-column>
      <el-table-column label="抓拍照片" width="160">
        <template slot-scope="{row}">
          <div class="imgs-wrap">
            <el-image :src="row.provide_attachment_data.attachment_access_url" :preview-src-list="[row.provide_attachment_data.attachment_access_url, row.user_data.face_data.attachment_access_url]"></el-image>
            <el-image :src="row.user_data.face_data.attachment_access_url" :preview-src-list="[row.provide_attachment_data.attachment_access_url, row.user_data.face_data.attachment_access_url]"></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="部门" prop="user_data.attr_data.user_attr_department"></el-table-column>
      <el-table-column label="职位" prop="user_data.attr_data.user_attr_title"></el-table-column>
      <el-table-column label="抓拍时间" prop="user_recognition_log_recognition_at"></el-table-column>
      <el-table-column label="到访项目" prop="user_recognition_log_project_name"></el-table-column>
      <el-table-column label="抓拍位置" prop="user_recognition_log_location_name"></el-table-column>
      <el-table-column label="操作" width="245">
        <template slot-scope="{row}">
          <el-button type="text" @click="info(row.user_id, row.project_id)">员工信息</el-button>
          <el-button type="text" @click="faceSearch(row.provide_attachment_data.attachment_id)">人脸搜索</el-button>
          <el-button type="text" @click="scan(row.provide_large_attachment_data.attachment_access_url)">查看大图</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    <el-drawer :title="infoDialog.title" :visible.sync="infoDialog.show" center size="85%" append-to-body>
      <project-staff-information :staffId="infoDialog.staffId" :id="infoDialog.projectId" v-if="infoDialog.show"></project-staff-information>
    </el-drawer>
    <el-drawer :title="faceDialog.title" :visible.sync="faceDialog.show" center size="85%" append-to-body>
      <search-by-picture :initVal="faceDialog.id" v-if="faceDialog.show"></search-by-picture>
    </el-drawer>
    <el-image-viewer :urlList="largeImage.value" :onClose="closeLargeImage" v-if="largeImage.show"></el-image-viewer>
  </div>
</template>

<script>
  import LogService from '@/io/log.js';
  import ProjectStaffInformation from '@/views/ProjectStaffInformation.vue';
  import SearchByPicture from '@/views/SearchByPicture.vue';
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue';

  export default {
    name: 'IdentificationLogStaff',
    data() {
      return {
        largeImage: {
          show: false,
          value: []
        },
        datas: [],
        loading: false,
        search: {
          name: '',
          position: '',
          project: '',
          period: [],
        },
        positionOptions: [],
        projectOptions: [],
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
        infoDialog: {
          title: '员工详情',
          show: false,
          staffId: null,
          projectId: null
        },
        faceDialog: {
          title: '人脸搜索',
          show: false,
          id: null
        }
      }
    },
    components: {
      ProjectStaffInformation,
      SearchByPicture,
      ElImageViewer
    },
    mounted () {
      this.$nextTick(() => {
        if (this.$refs.identifitionLogStaff) {
          this.initPage();
        }
      });
    },
    methods: {
      positionChange(value) {
        if (value) {
          this.projectOptions.forEach((val, index) => {
            if (val.value === value) {
              this.positionOptions = val.position;
            }
          });
        } else {
          this.positionOptions = [];
        }
        this.search.position = '';
      },
      initPage() {
        this.initParam().then(() => {
          this.initDatas();
        }).catch(() => {});
      },
      initParam() {
        return LogService.staffParamInfo().then(res => {
          this.projectOptions = res.data.user_recognition_log_search_structure.map(val => {
            return {
              value: val.value,
              position: val.child.user_recognition_log_location_name
            }
          });
        }).catch(() => {});
      },
      initDatas() {
        this.loading = true;
        LogService.staffLog(
          this.search.name,
          this.search.project,
          this.search.position,
          this.search.period ? this.search.period[0] : '',
          this.search.period ? this.search.period[1] : '',
          this.page.currentPage
        ).then(res => {
          this.datas = res.data.data;
          this.page.pageSize = res.data.per_page;
          this.page.total = res.data.total;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.name = '';
        this.search.project = '';
        this.search.position = '';
        this.search.period = [];
        this.searchParams();
      },
      info(staff_id, project_id) {
        this.infoDialog.show = true;
        this.infoDialog.staffId = staff_id;
        this.infoDialog.projectId = project_id;
      },
      faceSearch(id) {
        this.faceDialog.show = true;
        this.faceDialog.id = id;
      },
      scan(src) {
        this.setWaterMark('本图片仅用于视频监控', `${this.$store.state.userInfo.account_attr_data.account_attr_name}`);
        this.largeImage.value = [src];
        this.largeImage.show = true;
      },
      closeLargeImage() {
        this.removeWatermark();
        this.largeImage.value = [];
        this.largeImage.show = false;
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  /deep/ .el-drawer {
    .el-drawer__body {
      background-color: @color-1;
      padding: @distance;
    }
  }
</style>